import {Tween} from '@gongxigames/framework/core/fragments/tween/Tween';
import {Easing} from '@gongxigames/framework/core/fragments/tween/Easing';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';
import {BitmapText as PixiBitmapText, Text} from 'pixi.js';
import {ICurrencyFormatter} from '@gongxigames/framework/core/types';
import {BitmapText, RichText} from '@gongxigames/framework/core/fragments/display';

export type MeterTextObject = Text | PixiBitmapText | BitmapText | RichText;

export class Meter extends UpdateManager {
    protected _textObject: MeterTextObject;
    protected _tween: Tween;
    protected _valueWrapper: any = {value: 0, targetValue: 0};
    protected _formatter?: ICurrencyFormatter;
    private _updateCallback?: Function;
    private _valueName = 'value';

    constructor(textObject: MeterTextObject, easing: Function = Easing.Linear.None, formatter?: ICurrencyFormatter) {
        super();

        this._textObject = textObject;
        this._formatter = formatter;
        this._tween = new Tween(this._valueWrapper)
            .easing(easing)
            .onUpdate(this.onUpdate.bind(this));
        this.add(this._tween);
        this.onUpdate();
    }

    /**
     * if the win meter in incrementing this changes it immediately
     * to the final value.
     * OnCompleted won't be called
     */
    public snapToFinalValue(): void {
        this._tween.stop();
        this._valueWrapper.value = this._valueWrapper.targetValue;
        this.onUpdate();
    }

    public set(value: number): Meter {
        this.to(value, 0);
        this.snapToFinalValue();

        return this;
    }

    public from(value: number): Meter {
        this._tween.stop();
        this._valueWrapper.value = value;
        this._valueWrapper.targetValue = value;
        this.onUpdate();

        return this;
    }

    public to(value: number, time: number): Meter {
        this._valueWrapper.targetValue = value;

        if (!this._tween.updateManager) {
            this.add(this._tween);
        }

        this._tween.to({value}, time)
            .start();

        return this;
    }

    public getPredictedValue(time: number): string {
        return this.format(this._tween.getPredictedProperty(time, 'value'));
    }

    protected onUpdate(): void {
        const text = this.format(this._valueWrapper.value);

        if (this._textObject instanceof RichText) {
            this._textObject.updateText({values: {[this._valueName]: text}});
        } else {
            this._textObject.text = text;
        }
        this._updateCallback && this._updateCallback();
    }

    protected format(value: number): string {
        return this._formatter ? this._formatter.formatCents(value) : value.toFixed(2);
    }

    public get textObject(): MeterTextObject {
        return this._textObject;
    }

    public set textObject(value: MeterTextObject) {
        this._textObject = value;
    }

    public set onCompleteCallback(value: Function | undefined) {
        this._tween.onComplete(value);
    }

    public set updateCallback(value: Function) {
        this._updateCallback = value;
    }

    public set valueName(value: string) {
        this._valueName = value;
    }
}
